import { Directive, Input, OnChanges, SimpleChanges, HostListener } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator, ValidatorFn, Validators } from '@angular/forms';

// required for controls that are not basic html5 tags or for controls that need to validate dymamically 
//ex: client does not want daytime telephone to be a mandatory field
//ignore default value usefull for dropdowns where you want a default "select an option" type placeholder to be preselected
//if the [(ngModel)] value is a javascript object, then isObject should be set to true, and [ignoreValue] will typically be null
//if the [(ngModel)] value is a string or number, then isObject can be left as false, and the built-in logic will handle it well.
export function dynamicRequiredValidator(dynamicRequired: boolean, ignoreValue: any, isObject: boolean): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {

        if (!dynamicRequired)
            return null;

        var isValid;
        var isBoolean = false;

        if (isObject) {
            if (ignoreValue !== undefined) {
                isValid = control.value && (control.value !== ignoreValue);
            } else {
                isValid = !!control.value;
            }
        } else {
            var compareValue;

            if (typeof (control.value) === 'boolean') {
                isBoolean = true;
            }

            if (typeof (control.value) == 'number') {
                compareValue = String(control.value);
            }            
            else {
                compareValue = control.value;
            }

            isValid = (compareValue && (compareValue.length || isBoolean)) ? true : false;


            var valueToIgnore;
            if (typeof (ignoreValue) == 'number') {
                valueToIgnore = String(ignoreValue);
            }
            else {
                valueToIgnore = ignoreValue;
            }


            if (valueToIgnore) {
                if (isValid) {
                    if (compareValue == valueToIgnore) {
                        isValid = false;
                    }
                }

            }
        }
      

        return !isValid ? { 'dynamicRequired': { value: control.value } } : null;
        
    };
}




@Directive({
    selector: '[dynamicRequired]',
   // providers: [{ provide: NG_VALIDATORS, useExisting: DynamicRequiredValidatorDirective, multi: true }]
})
export class DynamicRequiredValidatorDirective  {
    @Input()
    dynamicRequired: AbstractControl;

    @Input()
    ignoreDefaultValue: any;

    @Input()
    isRequired: boolean;

    @Input()
    isObject: boolean;

    @HostListener('focusout', ['$event.target'])
    onFocusout(target) {

        this.validate();
    }

    @HostListener('document:triggerValidation', ['$event.target'])
    onsubmit() {
 
        this.validate();
    }

    validate() {
        var dynamicRequiredPassthrough = (this.isRequired) ? true : false;

        var isObjectPassthrough = (this.isObject) ? true : false;

        if (this.dynamicRequired && !this.dynamicRequired.errors) {

            this.dynamicRequired.setErrors(dynamicRequiredValidator(dynamicRequiredPassthrough, this.ignoreDefaultValue, isObjectPassthrough)(this.dynamicRequired));

        }
    }


}

